var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVtChannelOnBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 64,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    fill: "#ffb06b",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 58,
    height: 63,
    fill: "none"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "VT",
    transform: "translate(30 46)",
    fill: "#250bd1",
    fontSize: 38,
    fontFamily: "Quicksand-Bold, Quicksand",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.966,
    y: 0
  }, "VT"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtChannelOnBlue);
export default __webpack_public_path__ + "static/media/VTChannel-on-blue.6bac235510b6ba8878cdb45e8a15dec7.svg";
export { ForwardRef as ReactComponent };